import React, { createContext, useContext, useState, ReactNode } from "react";
import { FuelCode } from "../types/codeType";

interface CodesContextType {
  codes: FuelCode[];
  setCodes: React.Dispatch<React.SetStateAction<FuelCode[]>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  reloadCodes: boolean;
  setReloadCodes: React.Dispatch<React.SetStateAction<boolean>>;
}

const CodesContext = createContext<CodesContextType | undefined>(undefined);

export const CodesProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [codes, setCodes] = useState<FuelCode[]>([]);
  const [loading, setLoading] = useState(false);
  const [reloadCodes, setReloadCodes] = useState(false);

  return (
    <CodesContext.Provider value={{ codes, setCodes, loading, setLoading, reloadCodes, setReloadCodes }}>
      {children}
    </CodesContext.Provider>
  );
};

export const useCodes = () => {
  const context = useContext(CodesContext);
  if (!context) throw new Error("useCodes must be used within a CodesProvider");
  return context;
}; 